export interface SocialLinksProps {
  className?: string;
}

export function SocialLinks({ className = "" }: SocialLinksProps) {
  const socialLinks = [
    {
      name: "Facebook",
      href: "https://www.facebook.com/northamptonairport/",
      icon: "facebook"
    },
    {
      name: "YouTube", 
      href: "https://www.youtube.com/user/northamptonairport",
      icon: "youtube"
    },
    {
      name: "Instagram",
      href: "https://instagram.com/northampton.airport", 
      icon: "instagram"
    }
  ];

  return (
    <div className={`flex items-center gap-4 ${className}`}>
      {socialLinks.map((link) => (
        <a
          key={link.name}
          href={link.href}
          title={link.name}
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-600 hover:text-blue-600 transition-colors duration-200 text-sm"
        >
          <span className="sr-only">{link.name}</span>
          <span>{link.name}</span>
        </a>
      ))}
    </div>
  );
}